import { useSelector } from 'react-redux';
import { AIPromptRecommendations } from 'conversations-visitor-experience-components/customer-agent/AIPromptRecommendations';
import { getHasClickedWelcomePagePrompts } from '../selectors/getHasClickedWelcomePagePrompts';
import { useAIPromptRecommendations } from '../../hooks/useAIPromptRecommendations';
// @ts-expect-error untyped file
import { hasPersistedThreads } from '../../threads/selectors/hasPersistedThreads';
import styled from 'styled-components';
import { LEFT_ALIGNED } from 'conversations-visitor-experience-components/visitor-widget/constants/WidgetLocations';
import { useConsentPromptData } from '../../hooks/useConsentPromptData';
import { getIsUngatedForUpdatedChatLauncherExperience } from '../../widget-data/selectors/widgetDataSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const PromptsAboveInputWrapper = styled.div.withConfig({
  displayName: "AIPromptsContainerInsideChat__PromptsAboveInputWrapper"
})(["margin-bottom:", ";padding:0px 16px;"], ({
  isUngatedForUpdatedLauncher
}) => isUngatedForUpdatedLauncher ? '12px' : '8px');
const AIPromptsContainerInsideChat = () => {
  const hasClickedWelcomePagePrompts = useSelector(getHasClickedWelcomePagePrompts);
  const hasExistingThreads = useSelector(hasPersistedThreads);
  const isUngatedForUpdatedLauncher = useSelector(getIsUngatedForUpdatedChatLauncherExperience);
  const {
    showGdprConsentToProcessButton,
    renderCookieConsentPrompt
  } = useConsentPromptData();
  const explicitConsentEnabled = showGdprConsentToProcessButton || renderCookieConsentPrompt;
  const {
    recommendedQuestionsForAgent,
    coloring,
    isAIChatBot,
    handlePromptClick,
    handlePromptTrack
  } = useAIPromptRecommendations({
    clickedFrom: 'inside chat',
    shouldOpenWidget: false,
    shouldLoadStagedThread: false,
    errorMessage: 'Failed to publish message from AI prompts inside chat'
  });
  const shouldShow = isAIChatBot && !hasClickedWelcomePagePrompts && !hasExistingThreads && Array.isArray(recommendedQuestionsForAgent) && recommendedQuestionsForAgent.length > 0 && !explicitConsentEnabled;
  if (!shouldShow) {
    return null;
  }
  return /*#__PURE__*/_jsx(PromptsAboveInputWrapper, {
    "data-test-id": "ai-prompt-recommendations-inside-chat",
    isUngatedForUpdatedLauncher: isUngatedForUpdatedLauncher,
    children: /*#__PURE__*/_jsx(AIPromptRecommendations, {
      recommendedQuestionsForAgent: recommendedQuestionsForAgent,
      widgetLocation: LEFT_ALIGNED,
      coloring: coloring,
      insideChat: true,
      onPromptClick: handlePromptClick,
      onPromptTrack: handlePromptTrack,
      shouldShow: true,
      isUngatedForLauncherExperience: isUngatedForUpdatedLauncher
    })
  });
};
AIPromptsContainerInsideChat.displayName = 'AIPromptsContainerInsideChat';
export default AIPromptsContainerInsideChat;